import { pageDefinition } from 'site-modules/shared/pages/page';
import { getModelState } from 'client/data/luckdragon/model';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { CmsModel } from 'client/data/models/cms';
import { HomeModulesModel } from 'client/data/models/home-modules';
import { getPageLinksPath, LinkWidgetsModel } from 'client/data/models/link-widgets';
import { parseContent } from 'client/data/cms/content';
import { getMeta, getSeoImage } from 'site-modules/shared/utils/seo-helper';
import { getBreadcrumbSchema } from 'client/seo/schemas/breadcrumbs';
import { EdmundsDefaultDecorator } from 'site-modules/shared/pages/decorators/edmunds-default';
import { NEW_LANDING_CONTENT_FILE_PATH, NEW_LANDING_MORE_ABOUT_PATH, NewCarPricingPage } from './index';

export const pageOptions = {
  name: 'new_cars_index',
  category: 'new_cars_index',
  seo: state => {
    const modelState = getModelState(state);
    const newLandingContent = parseContent(modelState.get(`content["${NEW_LANDING_CONTENT_FILE_PATH}"]`, CmsModel));
    return {
      ...getMeta(newLandingContent),
      image: getSeoImage(newLandingContent),
      jsonld: [getBreadcrumbSchema(newLandingContent.child('breadcrumb').links())],
    };
  },
  preload: store => {
    const preloader = new ModelPreloader(store);
    preloader.resolve(`content["${NEW_LANDING_CONTENT_FILE_PATH}"]`, CmsModel);
    preloader.resolve(`content["${NEW_LANDING_MORE_ABOUT_PATH}"]`, CmsModel);
    preloader.resolve(`content["${NEW_LANDING_MORE_ABOUT_PATH}.author"]`, CmsModel);
    preloader.resolve('homeHeroContent', HomeModulesModel);
    preloader.resolve(getPageLinksPath(), LinkWidgetsModel);

    return preloader.load();
  },
  component: NewCarPricingPage,
  decorator: EdmundsDefaultDecorator,
};

export default pageDefinition(pageOptions);
